import { provideServerRendering } from '@angular/ssr';
import { ApplicationConfig, PLATFORM_ID, provideZoneChangeDetection, isDevMode, provideAppInitializer, inject, enableProdMode } from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideLottieOptions } from 'ngx-lottie';
import { FOOTER_BASE_HREF } from '@flitpay-internal/web-footer';
import { HEADER_BASE_HREF } from '@flitpay-internal/web-header';
import { isPlatformServer } from '@angular/common';
import { environment } from '../environments/environment';
import { provideMultiGraphQLClients, providePusherWithActivityManager } from '@flitpay-internal/graphql';
import { storageConstant } from '@flitpay-internal/resources';
import { COMMON_BASE_HREF } from '@flitpay-internal/ui-components';
import { provideModal } from '@flitpay-internal/modal';
import { provideServiceWorker } from '@angular/service-worker';
import { AppUpdateService } from './resources/_services/app-update.service';

if (environment.production) enableProdMode();

// const getApiUrl = (platformId: Object): string => {
// 	console.log('getApiUrl isPlatformServer', isPlatformServer(platformId));
// 	if (isPlatformServer(platformId)) {
// 		return environment.apiUrlOnServer ?? '';
// 	}
// 	return environment.apiUrl ?? '';
// };

// Check if we're on the server side (Node.js environment)
const isServerSide = typeof window === 'undefined';

const getGraphQLConfig = () => {
	// Use runtime check for server-side since inject() may not be available in this context
	const apiUrl = isServerSide
		? (environment.apiUrlOnServer ?? '')
		: (environment.apiUrl ?? '');

	return {
		default: {
			uri: apiUrl + 'graphql',
			jwtTokenKey: storageConstant?.jwtTokenKey || '',
			jwtRefreshKey: storageConstant?.refreshTokenKey || '',
			refreshTokenUri: apiUrl + 'graphql',
			tokenType: 'JWT' as const, // or 'Bearer'
			syncTokenRefresh: true,
			jwtRefreshBufferSeconds: 20, // 20 seconds before the token expires
		}
	};
};

export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection({ eventCoalescing: true }),
		// provideServerRendering(),
		provideRouter(routes,
			// withEnabledBlockingInitialNavigation(),
			withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })
		),
		provideClientHydration(),
		provideHttpClient(
			withFetch()
		),
		...provideMultiGraphQLClients(getGraphQLConfig()),
		// providePusher({
		// 	key: '9193d2554a9e83640898',
		// 	cluster: 'ap2',
		// 	apolloCLientName: 'default',
		// 	apiUrl: 'https://trueapi.flitpay.com/',
		// 	encryptKey: '9a084b972a2fb393bd0223ac8ccc141e0512ab6a6e8a8421e000cfe73e352c85',
		// 	debugMode: false,
		// }),
		// providePusherActivityManager({
		// 	...DEFAULT_DEV_CONFIG,
		// 	// inactivityTimeout: 15000,
		// 	// enableDebugMode: true,
		// }),
		providePusherWithActivityManager({
			key: '9193d2554a9e83640898',
			cluster: 'ap2',
			apolloCLientName: 'default',
			apiUrl: 'https://trueapi.flitpay.com/',
			encryptKey: '9a084b972a2fb393bd0223ac8ccc141e0512ab6a6e8a8421e000cfe73e352c85',
			debugMode: false,
		}, {
			inactivityTimeout: 300000, // 5 min
			tabHiddenTimeout: 180000, // 3 min
			activityDebounceTime: 500,
			enableActivityTracking: true,
			enableTabVisibilityTracking: true,
			enableDebugMode: false,
			showDebugComponent: false,
		}),
		provideLottieOptions({
			player: () => import('lottie-web'),
		}),
		provideModal(),
		{ provide: FOOTER_BASE_HREF, useValue: '/landing/' },
		{ provide: HEADER_BASE_HREF, useValue: '/landing/' },
		{ provide: COMMON_BASE_HREF, useValue: '/landing/' },
		provideServiceWorker('/landing/ngsw-worker.js', {
			enabled: environment.production,
			scope: '/landing/',
			registrationStrategy: 'registerWhenStable:30000'
		})
	]
};
